import { FC } from 'react';
import { CatTableCell } from 'components/blocks-components';
import Price from 'components/price';
import CommonAvailabilityWrapper from './common-availability-wrapper';
import { ReplacementParts } from 'services/dealerPriceAvailability/types';
import { DealerResponse } from 'services/dealer';
import { DealerData } from 'types/parts-diagram';

export interface CommonPartsTableProps {
  locale: string;
  dealerData: DealerData;
  item: ReplacementParts;
  currency: string;
  dealerInformation: DealerResponse;
  availRemoveInterimStockFlag: boolean;
  isShowSourcingDetailEnabled: boolean;
  isDeliveryEnabled: boolean;
  catcorp: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

const CommonPartsTable: FC<CommonPartsTableProps> = ({
  catcorp,
  item,
  currency,
  locale,
  dealerData,
  dealerInformation,
  availRemoveInterimStockFlag,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled,
  isRTL = false,
  currencyLdFeatureFlag = false
}) => {
  return (
    <>
      <CatTableCell>
        {!catcorp && !!item && (
          <CommonAvailabilityWrapper
            availabilityData={item}
            shouldDisplayLabel={false}
            isLoading={false}
            locale={locale}
            dealerData={dealerData}
            dealerInformation={dealerInformation}
            availRemoveInterimStockFlag={availRemoveInterimStockFlag}
            isShowSourcingDetailEnabled={isShowSourcingDetailEnabled}
            isDeliveryEnabled={isDeliveryEnabled}
          />
        )}
      </CatTableCell>
      <CatTableCell align="right">
        {!catcorp && !!item && (
          <Price
            price={item}
            currency={currency}
            isRTL={isRTL}
            currencyLdFeatureFlag={currencyLdFeatureFlag}
          />
        )}
      </CatTableCell>
    </>
  );
};

export default CommonPartsTable;
